import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'RecruitFilterPage',
    setup: function (__props) {
        var activeElement = ref(null);
        var handleToggle = function (elementType) {
            activeElement.value =
                activeElement.value === elementType ? null : elementType;
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", null, [
                _renderSlot(_ctx.$slots, "default", {
                    activeElement: activeElement.value,
                    handleToggle: handleToggle
                })
            ]));
        };
    }
});
